import React from "react";
import { Baby, Users } from "lucide-react";
import { cn } from "@/lib/utils";

interface GuestsCellProps {
  adultsCount: number;
  childrenCount: number;
  className?: string;
}

export const GuestsCell: React.FC<GuestsCellProps> = ({
  adultsCount,
  childrenCount,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-1 tracking-tight text-center text-[10px]",
        className,
      )}
    >
      {!!adultsCount && (
        <span className="flex items-center justify-center gap-1">
          <Users className="h-4 w-4" aria-hidden />
          <span>{adultsCount}</span>
        </span>
      )}
      {!!childrenCount && (
        <span className="flex items-center justify-center gap-1">
          <Baby className="h-4 w-4" aria-hidden />
          <span>{childrenCount}</span>
        </span>
      )}
    </div>
  );
};
